import loadable from '@loadable/component';
import { Loader } from '@/components';

export const AsyncPSD2BankAccountSelect = loadable(
  () => import('./PSD2SelectBankAccount'),
  {
    fallback: <Loader />,
  },
);
